<template>
  <div class="container">
    <div class="container">
      <span>{{ i18n.global.t("relogintoast.SoonLoggedOut") }}</span><br>
    </div>
    <div class="container">
      <button class="action"
              @click.stop="reloginClick"
      >
        {{ i18n.global.t("relogintoast.Yes") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import i18n from "../locales/i18n";
import { defineEmits } from 'vue'

const emit = defineEmits(['reloginClick'])

function reloginClick() {
    emit('close-toast');
    emit('reloginClick');
}

</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.action {
  @include btnSmall;
}
</style>
